(() => {
  const defaultEndpoint = '/apps/optimum-forms/uploads/authorize';
  const excerpt = (text) => text.replace(/<script\b[\s\S]*?<\/script>/gi, ' ').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim().slice(0, 160);

  async function parseResponse(response, endpoint) {
    const text = await response.text();
    const type = response.headers.get('content-type') || '';
    if (type.includes('application/json')) {
      try {
        return text ? JSON.parse(text) : {};
      } catch {
        throw new Error(`Invalid JSON response (HTTP ${response.status}) from ${endpoint}: ${excerpt(text) || response.statusText}`);
      }
    }
    throw new Error(`Unexpected response (HTTP ${response.status}) from ${endpoint}: ${excerpt(text) || response.statusText}`);
  }

  function validate(files, maxFiles, maxBytes) {
    if (files.length > maxFiles) return `Upload up to ${maxFiles} files.`;
    if (files.some((file) => file.size > maxBytes)) return `Each file must be ${Math.round(maxBytes / 1048576)}MB or smaller.`;
    return '';
  }

  async function upload(input, submissionId, turnstileToken = '') {
    const files = Array.from(input.files || []);
    if (!files.length) return [];
    const maxFiles = Number(input.dataset?.maxFiles || 5);
    const maxBytes = Number(input.dataset?.maxBytes || 10485760);
    const error = validate(files, maxFiles, maxBytes);
    const status = input.closest('form')?.querySelector('[data-upload-status]');
    if (error) {
      if (status) status.textContent = error;
      throw new Error(error);
    }

    const endpoint = input.dataset?.uploadEndpoint || defaultEndpoint;
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({
        submissionId,
        turnstileToken,
        files: files.map((file) => ({ name: file.name, contentType: file.type || 'application/octet-stream', size: file.size })),
      }),
    });
    const result = await parseResponse(response, endpoint);
    if (!response.ok) throw new Error(result.message || 'Upload failed');
    await Promise.all(result.files.map((authorized, index) => fetch(authorized.url, {
      method: 'PUT',
      headers: { 'content-type': files[index].type || 'application/octet-stream' },
      body: files[index],
    }).then((put) => {
      if (!put.ok) throw new Error('Upload failed');
    })));
    if (status) status.textContent = files.length ? 'Files attached.' : '';
    return result.files.map((file) => file.key);
  }

  window.OptimumFileUploader = { defaultEndpoint, parseResponse, validate, upload };
})();
